const SubmissionType = {
  CONTACT: 'CONTACT',
  VEHICLE: 'VEHICLE',
  ACCOMMODATION: 'ACCOMMODATION',
  REMINDER: 'REMINDER',
  BOOK_HOTEL: 'BOOK_HOTEL',
  BOOK_BRIEFING: 'BOOK_BRIEFING',
  STAY: 'STAY',
  BUY_BOOK: 'BUY_BOOK',
}

export default SubmissionType
